export default __webpack_public_path__ + "static/media/right-blue.8936d996.svg";